import React from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts, moduleColors } from "../theme";
import { View, Text, Card, Press, ScreenHeader, EmptyState, ProgressBar } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";
import { AREAS, areaById, t } from "../content";

export default function Weak() {
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  const { weakAreas } = useAppState();
  const weak = weakAreas();
  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("weakTopics")} onBack={() => navigate(-1)} />
      {weak.length === 0 ? (
        <EmptyState icon="target" title={tr("weakTopicsDesc")} sub={tr("questionsAnswered")} />
      ) : (
        <View style={{ padding: 20 }}>
          {weak.map(({ areaId, pct }) => {
            const area = areaById(areaId);
            const idx = AREAS.findIndex((a) => a.id === areaId);
            const mc = moduleColors[idx];
            const color = pct >= 75 ? colors.success : pct >= 50 ? colors.warning : colors.error;
            const label = pct >= 75 ? tr("strong") : pct >= 50 ? tr("improve") : tr("critical");
            return (
              <Press key={areaId} testID={`weak-${areaId}`} onClick={() => navigate(`/session?mode=area&area=${areaId}`)}>
                <Card style={{ marginBottom: 10 }}>
                  <View row style={{ justifyContent: "space-between", marginBottom: 8, alignItems: "center" }}>
                    <Text numberOfLines={1} style={{ flex: 1, fontWeight: fonts.semibold, fontSize: 14, color: colors.onSurface }}>{area.num} · {t(area.title, lang)}</Text>
                    <Text style={{ fontWeight: fonts.bold, fontSize: 14, color }}>{pct}%</Text>
                  </View>
                  <ProgressBar progress={pct} color={mc.accent} />
                  <View row style={{ justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
                    <Text style={{ fontWeight: fonts.medium, fontSize: 12, color }}>{label}</Text>
                    <View row style={{ alignItems: "center", gap: 4 }}>
                      <Text style={{ fontWeight: fonts.semibold, fontSize: 12, color: colors.brandPrimary }}>{tr("practiceQuiz")}</Text>
                      <Icon name="arrow-right" size={14} color={colors.brandPrimary} weight="bold" />
                    </View>
                  </View>
                </Card>
              </Press>
            );
          })}
        </View>
      )}
    </View>
  );
}
